import React, { useState } from 'react'
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FaRegEdit } from "react-icons/fa";
import { FaCaretRight } from "react-icons/fa";
import { SlLocationPin, SlEnvolope } from "react-icons/sl";
import { GoCircle } from "react-icons/go";
import Select from 'react-select';
import AddressModal from '../DocumentShiping/AddressModel.js';
import AddressDetailsModel from '../DocumentShiping/AddressDetailsModel.js';
import DeliveryDetailsModel from '../DocumentShiping/DeliveryDetailsModel.js';
import DeliveryModal from '../DocumentShiping/DeliveryModal.js';
import PaymentTotalModel from '../DocumentShiping/PaymentTotalModel.js';
import { LuPlaneTakeoff } from "react-icons/lu";
import useScrollToTop from '../components/useScrollToTop.js';
import { IoLocationSharp } from "react-icons/io5";
import SpinLoader from '../components/SpinLoader.js';
import { FaCalculator, FaPlaneDeparture, FaTruckRampBox } from "react-icons/fa6";


const ForeignAir = () => {

    useScrollToTop();

    const [showModal, setShowModal] = useState(false);
    const [showModalAddress, setShowModalAddress] = useState(false);

    const [deliveryshowModal, setdeliveryShowModal] = useState(false);
    const [deliveryModal, setdeliveryModal] = useState(false);

    const [paymentShowModel, setPaymentShowModel] = useState(false);

    const weightOptions = [
        { value: "0.5 Kg", label: "0.5 KG" },
        { value: "1 Kg", label: "1 Kg" },
        { value: "2 Kg", label: "2 Kg" },
        { value: "3 Kg", label: "3 Kg" },
        { value: "4 Kg", label: "4 Kg" },
        { value: "5 Kg", label: "5 Kg" },
        { value: "6 Kg", label: "6 Kg" },
        { value: "7 Kg", label: "7 Kg" },
        { value: "8 Kg", label: "8 Kg" },
        { value: "9 Kg", label: "9 Kg" },
        { value: "10 Kg", label: "10 Kg" },
        { value: "11 Kg", label: "11 Kg" },
        { value: "12 Kg", label: "12 Kg" },
        { value: "13 Kg", label: "13 Kg" },
        { value: "14 Kg", label: "14 Kg" },
        { value: "15 Kg", label: "15 Kg" },
        { value: "16 Kg", label: "16 Kg" },
        { value: "17 Kg", label: "17 Kg" },
        { value: "18 Kg", label: "18 Kg" },
        { value: "19 Kg", label: "19 Kg" },
        { value: "20 Kg", label: "20 Kg" },
        { value: "21 Kg", label: "21 Kg" },
        { value: "22 Kg", label: "22 Kg" },
        { value: "23 Kg", label: "23 Kg" },
        { value: "24 Kg", label: "24 Kg" },
        { value: "25 Kg", label: "25 Kg" },
        { value: "26 Kg", label: "26 Kg" },
        { value: "27 Kg", label: "27 Kg" },
        { value: "28 Kg", label: "28 Kg" },
        { value: "29 Kg", label: "29 Kg" },
        { value: "30 Kg", label: "30 Kg" },
        { value: "31 Kg", label: "31 Kg" },
        { value: "32 Kg", label: "32 Kg" },
        { value: "33 Kg", label: "33 Kg" },
        { value: "34 Kg", label: "34 Kg" },
        { value: "35 Kg", label: "35 Kg" },
        { value: "36 Kg", label: "36 Kg" },
        { value: "37 Kg", label: "37 Kg" },
        { value: "38 Kg", label: "38 Kg" },
        { value: "39 Kg", label: "39 Kg" },
        { value: "40 Kg", label: "40 Kg" },
        { value: "41 Kg", label: "41 Kg" },
        { value: "42 Kg", label: "42 Kg" },
        { value: "43 Kg", label: "43 Kg" },
        { value: "44 Kg", label: "44 Kg" },
        { value: "45 Kg", label: "45 Kg" },
        { value: "46 Kg", label: "46 Kg" },
        { value: "47 Kg", label: "47 Kg" },
        { value: "48 Kg", label: "48 Kg" },
        { value: "49 Kg", label: "49 Kg" },
        { value: "50 Kg", label: "50 Kg" },
        { value: "51 Kg", label: "51 Kg" },
    ];

    const india = [
        { value: "India (Bharat)", label: "India (Bharat)" },
    ];

    const allCountry = [
        { value: "Australia", label: "Australia" },
        { value: "Albania", label: "Albania" },
        { value: "Algeria", label: "Algeria" },
        { value: "Andorra", label: "Andorra" },
        { value: "Angola", label: "Angola" },
        { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
        { value: "Argentina", label: "Argentina" },
        { value: "Armenia", label: "Armenia" },
        { value: "Afghanistan", label: "Afghanistan" },
        { value: "Austria", label: "Austria" },
        { value: "Azerbaijan", label: "Azerbaijan" },
        { value: "Bahamas", label: "Bahamas" },
        { value: "Bahrain", label: "Bahrain" },
        { value: "Bangladesh", label: "Bangladesh" },
        { value: "Barbados", label: "Barbados" },
        { value: "Belarus", label: "Belarus" },
        { value: "Belgium", label: "Belgium" },
        { value: "Belize", label: "Belize" },
        { value: "Benin", label: "Benin" },
        { value: "Bhutan", label: "Bhutan" },
        { value: "Bolivia", label: "Bolivia" },
        { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
        { value: "Botswana", label: "Botswana" },
        { value: "Brazil", label: "Brazil" },
        { value: "Brunei", label: "Brunei" },
        { value: "Bulgaria", label: "Bulgaria" },
        { value: "Burkina Faso", label: "Burkina Faso" },
        { value: "Burundi", label: "Burundi" },
        { value: "Cabo Verde", label: "Cabo Verde" },
        { value: "Cambodia", label: "Cambodia" },
        { value: "Cameroon", label: "Cameroon" },
        { value: "Canada", label: "Canada" },
        { value: "Central African Rep.", label: "Central African Rep." },
        { value: "Chad", label: "Chad" },
        { value: "Chile", label: "Chile" },
        { value: "China", label: "China" },
        { value: "Colombia", label: "Colombia" },
        { value: "Comoros", label: "Comoros" },
        { value: "Congo, Dem. Rep.", label: "Congo, Dem. Rep." },
        { value: "Congo, Republic", label: "Congo, Republic" },
        { value: "Costa Rica", label: "Costa Rica" },
        { value: "Croatia", label: "Croatia" },
        { value: "Cuba", label: "Cuba" },
        { value: "Cyprus", label: "Cyprus" },
        { value: "Czech Republic", label: "Czech Republic" },
        { value: "Denmark", label: "Denmark" },
        { value: "Djibouti", label: "Djibouti" },
        { value: "Dominica", label: "Dominica" },
        { value: "Dominican Republic", label: "Dominican Republic" },
        { value: "Ecuador", label: "Ecuador" },
        { value: "Egypt", label: "Egypt" },
        { value: "El Salvador", label: "El Salvador" },
        { value: "Equatorial Guinea", label: "Equatorial Guinea" },
        { value: "Eritrea", label: "Eritrea" },
        { value: "Estonia", label: "Estonia" },
        { value: "Eswatini", label: "Eswatini" },
        { value: "Ethiopia", label: "Ethiopia" },
        { value: "Fiji", label: "Fiji" },
        { value: "Finland", label: "Finland" },
        { value: "France", label: "France" },
        { value: "Gabon", label: "Gabon" },
        { value: "Gambia", label: "Gambia" },
        { value: "Georgia", label: "Georgia" },
        { value: "Germany", label: "Germany" },
        { value: "Ghana", label: "Ghana" },
        { value: "Greece", label: "Greece" },
        { value: "Grenada", label: "Grenada" },
        { value: "Guatemala", label: "Guatemala" },
        { value: "Guinea", label: "Guinea" },
        { value: "Guinea-Bissau", label: "Guinea-Bissau" },
        { value: "Guyana", label: "Guyana" },
        { value: "Haiti", label: "Haiti" },
        { value: "Honduras", label: "Honduras" },
        { value: "Hungary", label: "Hungary" },
        { value: "Iceland", label: "Iceland" },
        { value: "India", label: "India" },
        { value: "Indonesia", label: "Indonesia" },
        { value: "Iran", label: "Iran" },
        { value: "Iraq", label: "Iraq" },
        { value: "Ireland", label: "Ireland" },
        { value: "Israel", label: "Israel" },
        { value: "Italy", label: "Italy" },
        { value: "Jamaica", label: "Jamaica" },
        { value: "Japan", label: "Japan" },
        { value: "Jordan", label: "Jordan" },
        { value: "Kazakhstan", label: "Kazakhstan" },
        { value: "Kenya", label: "Kenya" },
        { value: "Kiribati", label: "Kiribati" },
        { value: "Korea, North", label: "Korea, North" },
        { value: "Korea, South", label: "Korea, South" },
        { value: "Kosovo", label: "Kosovo" },
        { value: "Kuwait", label: "Kuwait" },
        { value: "Kyrgyzstan", label: "Kyrgyzstan" },
        { value: "Laos", label: "Laos" },
        { value: "Latvia", label: "Latvia" },
        { value: "Lebanon", label: "Lebanon" },
        { value: "Lesotho", label: "Lesotho" },
        { value: "Liberia", label: "Liberia" },
        { value: "Libya", label: "Libya" },
        { value: "Liechtenstein", label: "Liechtenstein" },
        { value: "Lithuania", label: "Lithuania" },
        { value: "Luxembourg", label: "Luxembourg" },
        { value: "Madagascar", label: "Madagascar" },
        { value: "Malawi", label: "Malawi" },
        { value: "Malaysia", label: "Malaysia" },
        { value: "Maldives", label: "Maldives" },
        { value: "Mali", label: "Mali" },
        { value: "Malta", label: "Malta" },
        { value: "Marshall Islands", label: "Marshall Islands" },
        { value: "Mauritania", label: "Mauritania" },
        { value: "Mauritius", label: "Mauritius" },
        { value: "Mexico", label: "Mexico" },
        { value: "Micronesia", label: "Micronesia" },
        { value: "Moldova", label: "Moldova" },
        { value: "Monaco", label: "Monaco" },
        { value: "Mongolia", label: "Mongolia" },
        { value: "Montenegro", label: "Montenegro" },
        { value: "Morocco", label: "Morocco" },
        { value: "Mozambique", label: "Mozambique" },
        { value: "Myanmar", label: "Myanmar" },
        { value: "Namibia", label: "Namibia" },
        { value: "Nauru", label: "Nauru" },
        { value: "Nepal", label: "Nepal" },
        { value: "Netherlands", label: "Netherlands" },
        { value: "New Zealand", label: "New Zealand" },
        { value: "Nicaragua", label: "Nicaragua" },
        { value: "Niger", label: "Niger" },
        { value: "Nigeria", label: "Nigeria" },
        { value: "North Macedonia", label: "North Macedonia" },
        { value: "Norway", label: "Norway" },
        { value: "Oman", label: "Oman" },
        { value: "Pakistan", label: "Pakistan" },
        { value: "Palau", label: "Palau" },
        { value: "Palestine", label: "Palestine" },
        { value: "Panama", label: "Panama" },
        { value: "Papua New Guinea", label: "Papua New Guinea" },
        { value: "Paraguay", label: "Paraguay" },
        { value: "Peru", label: "Peru" },
        { value: "Philippines", label: "Philippines" },
        { value: "Poland", label: "Poland" },
        { value: "Portugal", label: "Portugal" },
        { value: "Qatar", label: "Qatar" },
        { value: "Romania", label: "Romania" },
        { value: "Russia", label: "Russia" },
        { value: "Rwanda", label: "Rwanda" },
        { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
        { value: "Saint Lucia", label: "Saint Lucia" },
        { value: "Saint Vincent Grenadines", label: "Saint Vincent Grenadines" },
        { value: "Samoa", label: "Samoa" },
        { value: "San Marino", label: "San Marino" },
        { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
        { value: "Saudi Arabia", label: "Saudi Arabia" },
        { value: "Senegal", label: "Senegal" },
        { value: "Serbia", label: "Serbia" },
        { value: "Seychelles", label: "Seychelles" },
        { value: "Sierra Leone", label: "Sierra Leone" },
        { value: "Singapore", label: "Singapore" },
        { value: "Slovakia", label: "Slovakia" },
        { value: "Slovenia", label: "Slovenia" },
        { value: "Solomon Islands", label: "Solomon Islands" },
        { value: "Somalia", label: "Somalia" },
        { value: "South Africa", label: "South Africa" },
        { value: "South Sudan", label: "South Sudan" },
        { value: "Spain", label: "Spain" },
        { value: "Sri Lanka", label: "Sri Lanka" },
        { value: "Sudan", label: "Sudan" },
        { value: "Suriname", label: "Suriname" },
        { value: "Sweden", label: "Sweden" },
        { value: "Switzerland", label: "Switzerland" },
        { value: "Syria", label: "Syria" },
        { value: "Taiwan", label: "Taiwan" },
        { value: "Tajikistan", label: "Tajikistan" },
        { value: "Tanzania", label: "Tanzania" },
        { value: "Thailand", label: "Thailand" },
        { value: "Timor-Leste", label: "Timor-Leste" },
        { value: "Togo", label: "Togo" },
        { value: "Tonga", label: "Tonga" },
        { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
        { value: "Tunisia", label: "Tunisia" },
        { value: "Turkey", label: "Turkey" },
        { value: "Turkmenistan", label: "Turkmenistan" },
        { value: "Tuvalu", label: "Tuvalu" },
        { value: "Uganda", label: "Uganda" },
        { value: "Ukraine", label: "Ukraine" },
        { value: "United Arab Emirates", label: "United Arab Emirates" },
        { value: "United Kingdom", label: "United Kingdom" },
        { value: "United States", label: "United States" },
        { value: "Uruguay", label: "Uruguay" },
        { value: "Uzbekistan", label: "Uzbekistan" },
        { value: "Vanuatu", label: "Vanuatu" },
        { value: "Vatican City", label: "Vatican City" },
        { value: "Venezuela", label: "Venezuela" },
        { value: "Vietnam", label: "Vietnam" },
        { value: "Yemen", label: "Yemen" },
        { value: "Zambia", label: "Zambia" },
        { value: "Zimbabwe", label: "Zimbabwe" }
    ];


    const europeSelf = {
        mainTitle: "European Countries (Duty Paid)",
        destinations: [
            {
                destination: "UNITED KINGDOM",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "NETHERLANDS",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "AUSTRIA",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "BELGIUM",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "CZECH Republic",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "DENMARK",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "FINLAND",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "FRANCE",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "GERMANY",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "HUNGARY",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "IRELAND",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "ITALY",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "LATVIA",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "LITHUANIA",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "LUXEMBOURG",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "POLAND",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "PORTUGAL",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "ROMANIA",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SLOVAKIA",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SLOVENIA",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SPAIN",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SWEDEN",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
        ],
    }

    const asiaSelf = {
        mainTitle: "European Countries (Duty Paid)",
        destinations: [
            {
                destination: "BANGLADESH",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "MALDIVES",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "NEPAL",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SRI LANKA",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SRI LANKA(DUTYPAID)",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "HONG KONG",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "MALAYSIA",
                price: "₹495",
                deliveryTime: "5 - 7 BUSINESS DAYS",
                image: "https://assets.studies-overseas.com/nw_usa4_8d52abb15b.svg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "SINGAPORE",
                price: "₹460",
                deliveryTime: "8 - 12 BUSINESS DAYS",
                image: "https://workpermit.com/sites/default/files/styles/large/public/22324191185_cf010e09e9_z.jpg?itok=nUorLq-7",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "TAIWAN",
                price: "₹275",
                deliveryTime: "5 - 8 BUSINESS DAYS",
                image: "https://tfa.imgix.net/guides/singapore/new-tower-marina-bay-sands.jpg?fit=max&auto=format&w=1024",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "THAILAND",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
            {
                destination: "VIETNAM",
                price: "₹350",
                deliveryTime: "5 - 10 BUSINESS DAYS",
                image: "https://www.focus-info.org/wp-content/uploads/2022/07/london-blog-1.jpg",
                details: {
                    id: 1, // Unique ID for the object
                    priceDetails: [
                        { weight: "500 gms", price: "₹1000" },
                        { weight: "1 kg", price: "₹1250" },
                        { weight: "2 kg", price: "₹1600" },
                        { weight: "3 kg", price: "₹1700" },
                        { weight: "4 kg", price: "₹1700" },
                        { weight: "5 kg", price: "₹1700" },
                        { weightRange: "6 Kg - 10 Kg", price: "₹350" },
                        { weightRange: "11 Kg - 20 Kg", price: "₹1250" },
                        { weightRange: "21 Kg - 30 Kg", price: "₹1600" },
                    ],
                    dutiesTaxes: "Not Applicable (It is Duty Paid Service)",
                    estimatedDeliveryTime: "5 to 8 Days",
                    weightLimit: "Maximum weight per box: 30 kg",
                    discounts: "Get 50% off on Global Shipment services to any country! Don't miss this limited-time offer. Ship globally at half the cost today!",
                    pickupPackaging: "Pickup is free across India. Basic packaging and label application will be done on your side. Once the parcel reaches our nearest warehouse, we will ensure it is repacked with perfect and secure packaging.",
                    multipleBoxes: "Not Allowed",
                    restrictedItems: "Medicine, Cosmetics, Ghee, Liquids & Batteries Not Allowed",
                    deliveryAttempts: "Confirm address with shipper and consignee to avoid address correction charges.",
                    suitableFor: "Household, Chemicals, Electronics, Cosmetics, Machinery, Tools, Textile Products, etc.",
                },
            },
        ],
    }


    const [expandedIndex, setExpandedIndex] = useState(null);
    // console.log('✌️expandedIndex --->', expandedIndex);

    const toggleAccordion = (index) => {
        // Toggle the accordion; close if already open
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <div>
            <Header />
            {/* <div className="relative isolate overflow-hidden bg-slate-900 py-24 sm:py-24">
                <img
                    alt=""
                    src={tailwind}
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
                />
                <div
                    aria-hidden="true"
                    className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
                >
                    <div
                        style={{
                            clipPath:
                                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                        }}
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                    />
                </div>
                <div
                    aria-hidden="true"
                    className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
                >
                    <div
                        style={{
                            clipPath:
                                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                        }}
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                    />
                </div>
                <div className="mx-auto max-w-auto px-6 lg:px-8">
                    <div className="bg-white rounded-lg shadow-md p-6 md:flex md:items-center md:space-x-6 max-w-4xl mx-auto">
                        <div className="flex justify-center md:justify-start mb-4 md:mb-0">
                        <img src={planeImage} className="rounded-xl hover:opacity-80" alt="Plane" />
                        </div>
                        <div>
                            <h2 className="text-sm font-semibold mb-1 text-gray-800">EXCITING TIMES AHEAD</h2>
                            <h2 className="font-semibold mb-4 text-gray-900">currently undergoing essential maintenance to bring you new features, improvements, and a better overall experience.</h2>
                            <h2 className="text-lg font-semibold mb-1 text-gray-900">Global Shipment</h2>
                            <div className="text-sm flex items-center">
                                <span className="bg-slate-200 px-4 py-0.5 rounded-lg mr-2">
                                    Maximum Weight
                                </span>
                            </div>
                            <p className="mt-4 text-lg font-semibold text-gray-900">
                                Unified Tracking Experience
                            </p>
                            <p className="text-sm text-gray-500 mt-2">
                                Ship your Global orders to over 220+ countries and territories with India’s leading cross border Shipment solution.
                                Our Global shipping platform makes it simpler to serve your Global customers and make it big in the global arena.
                            </p>
                        </div>
                    </div>
                </div>
            </div> */}


            <div className="relative isolate overflow-hidden bg-slate-900 py-16 sm:pt-14">
                <img
                    src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/tailwindimg.avif"
                    alt=""
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
                />
                <div
                    className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div
                    className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div className="mx-auto  max-w-auto md:px-8 lg:px-8">
                    <div className='flex flex-col lg:flex-row lg:space-x-3 gap-y-10'>
                        <div className="lg:w-2/3 md:rounded-l-lg rounded-none md:py-8 md:px-9 p-6 bg-white ring-1 ring-slate-900/5 shadow-md">

                            <div className="flex justify-between items-center md:px-0 mt-6 md:mt-0 mb-6">
                                {/* Left Section */}
                                {/* <div className="flex items-center">
                                    <FaPlaneDeparture className="text-slate-800 text-3xl mt-1" />
                                    <h1 className="font-bold text-xl ml-3">
                                        This Service is Temporarily Unavailable Due to Maintenance
                                    </h1>
                                </div> */}
                                <h1 className="text-lg md:flex font-bold text-gray-800 mb-4">
                                    <FaPlaneDeparture className="text-3xl me-3" />This Service is Temporarily Unavailable Due to Maintenance
                                </h1>

                                {/* Right Section */}
                                <h1 className="font-semibold text-sm lg:text-sm text-gray-600 hidden lg:block">
                                    1 / 1
                                </h1>
                            </div>


                            <p className="mb-5 text-sm">At UK Logistics, we make Global shipping easy and transparent. Our free rate calculator is designed to help you quickly and accurately estimate Shipment charges based on everything that matters—weight, destination, and more.</p>
                            <Formik
                                initialValues={{
                                    pickUpPincode: '',
                                    deliveryPincode: '',
                                    weight: '',
                                    length: '',
                                    height: '',
                                    breadth: '',
                                }}
                            // validationSchema={validationSchema}
                            // onSubmit={handleSubmit}

                            >
                                {({ isSubmitting, resetForm, setFieldValue }) => (
                                    <>
                                        <p className="text-gray-400 inline-block font-normal mb-6 underline decoration-dashed underline-offset-8 cursor-pointer"
                                        // onClick={() => handleReset(resetForm)}
                                        >Reset</p>
                                        <Form>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
                                                {/* <div>
                                                    <label>Pick-up Pincode <span className="text-red-500">*</span></label>
                                                    <div className="mt-2">
                                                        <div className="flex items-center border border-slate-700 p-1.5 rounded-md">
                                                            <IoLocationSharp className="text-gray-500 mr-2" />
                                                            <Field
                                                                type="text"
                                                                name="pickUpPincode"
                                                                className="w-full focus:outline-none"
                                                                placeholder="Pick-up"
                                                            // onChange={(e) => handleChange(e, setFieldValue, 'pickUpPincode')}
                                                            />
                                                        </div>
                                                        <ErrorMessage name="pickUpPincode" component="div" className="text-red-600 text-sm mt-1" />
                                                    </div>
                                                </div> */}

                                                {/* <div>
                                                    <label>Delivery Pincode <span className="text-red-500">*</span></label>
                                                    <div className="mt-2">
                                                        <div className="flex items-center border border-slate-700 p-1.5 rounded-md">
                                                            <IoLocationSharp className="text-gray-500 mr-2" />
                                                            <Field
                                                                type="text"
                                                                name="deliveryPincode"
                                                                className="w-full focus:outline-none"
                                                                placeholder="Delivery"
                                                            // onChange={(e) => handleChange(e, setFieldValue, 'deliveryPincode')}
                                                            />
                                                        </div>
                                                        <ErrorMessage name="deliveryPincode" component="div" className="text-red-600 text-sm mt-1" />
                                                    </div>
                                                </div> */}
                                                <div className="relative z-40">
                                                    <label>Ship From <span className="text-red-500">*</span></label>
                                                    <div className="mt-2 z-40">
                                                        <Field name="weight">
                                                            {({ field, form }) => {
                                                                const selectedOptionindia = india.find(option => option.value === field.value);
                                                                return (
                                                                    <Select
                                                                        value={selectedOptionindia}
                                                                        options={india}
                                                                        className="w-full focus:outline-none z-50"
                                                                        styles={{
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                '&:hover': { borderColor: '#2b2b2b' },
                                                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            singleValue: (base) => ({
                                                                                ...base,
                                                                                color: '#000000',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            option: (base, state) => ({
                                                                                ...base,
                                                                                backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                color: state.isSelected ? 'white' : '#000000',
                                                                                '&:hover': {
                                                                                    backgroundColor: '#909090',
                                                                                    color: '#000000',
                                                                                },
                                                                                zIndex: 1050,
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                zIndex: 1050,
                                                                                position: 'absolute',
                                                                            }),
                                                                        }}
                                                                        isSearchable={false}
                                                                        placeholder="Select India"
                                                                        onChange={option => form.setFieldValue(field.name, option.value)}
                                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                                    />
                                                                );
                                                            }}
                                                        </Field>
                                                        <ErrorMessage name="weight" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                    </div>
                                                </div>
                                                <div className="relative z-30">
                                                    <label>
                                                        Ship To <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="mt-2 z-30">
                                                        <Field name="allCountry">
                                                            {({ field, form }) => {
                                                                const selectedOption = allCountry.find(option => option.value === field.value);
                                                                return (
                                                                    <Select
                                                                        value={selectedOption}
                                                                        options={allCountry.map(option => ({
                                                                            ...option,
                                                                            isDisabled: true, // Disable all options
                                                                        }))}
                                                                        className="w-full focus:outline-none z-50"
                                                                        styles={{
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                '&:hover': { borderColor: '#2b2b2b' },
                                                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            singleValue: (base) => ({
                                                                                ...base,
                                                                                color: '#000000',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            option: (base, state) => ({
                                                                                ...base,
                                                                                backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                color: state.isSelected ? 'white' : '#BFBFBF',
                                                                                '&:hover': {
                                                                                    backgroundColor: '#909090',
                                                                                    color: '#000000',
                                                                                },
                                                                                zIndex: 1050,
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                zIndex: 1050,
                                                                                position: 'absolute',
                                                                            }),
                                                                        }}
                                                                        isSearchable={true}
                                                                        placeholder="Search Country"
                                                                        onChange={option => form.setFieldValue(field.name, option.value)}
                                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                                    />
                                                                );
                                                            }}
                                                        </Field>
                                                        <ErrorMessage name="weight" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                    </div>
                                                </div>

                                                <div className="relative z-20">
                                                    <label>Weight (Kg) <span className="text-red-500">*</span></label>
                                                    <div className="mt-2 z-20">
                                                        <Field name="weight">
                                                            {({ field, form }) => {
                                                                const selectedOption = weightOptions.find(option => option.value === field.value);
                                                                return (
                                                                    <Select
                                                                        value={selectedOption}
                                                                        // options={weightOptions}
                                                                        options={weightOptions.map(option => ({
                                                                            ...option,
                                                                            isDisabled: true, // Disable all options
                                                                        }))}
                                                                        className="w-full focus:outline-none z-50"
                                                                        styles={{
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                '&:hover': { borderColor: '#2b2b2b' },
                                                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            singleValue: (base) => ({
                                                                                ...base,
                                                                                color: '#000000',
                                                                                zIndex: 1050,
                                                                            }),
                                                                            option: (base, state) => ({
                                                                                ...base,
                                                                                backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                color: state.isSelected ? 'white' : '#BFBFBF',
                                                                                '&:hover': {
                                                                                    backgroundColor: '#909090',
                                                                                    color: '#000000',
                                                                                },
                                                                                zIndex: 1050,
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                zIndex: 1050,
                                                                                position: 'absolute',
                                                                            }),
                                                                        }}
                                                                        isSearchable={false}
                                                                        placeholder="Select weight"
                                                                        onChange={option => form.setFieldValue(field.name, option.value)}
                                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                                    />
                                                                );
                                                            }}
                                                        </Field>
                                                        <ErrorMessage name="weight" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="flex justify-end mt-6 cursor-not-allowed">
                                                <button
                                                    type="submit"
                                                    disabled
                                                    className={`py-2.5 px-3 w-full inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-slate-800 text-white text-sm 
            ${isSubmitting ? 'cursor-not-allowed bg-slate-600' : 'hover:bg-slate-900'} focus:outline-none`}
                                                >
                                                    {isSubmitting ? (
                                                        <div className="flex items-center">
                                                            <span className="mr-2">Loading...</span>
                                                            <SpinLoader /> 
                                                  </div>
                                                    ) : ( 
                                                    <>
                                                        <FaCalculator className="text-white me-2 text-lg" />
                                                        Calculate
                                                    </>
                                                    )}
                                                </button>
                                            </div> */}

                                            <div className="flex justify-end mt-6">
                                                <button
                                                    type="submit"
                                                    disabled
                                                    className="py-2.5 px-3 w-full inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-slate-800 text-white text-sm cursor-not-allowed focus:outline-none"
                                                >
                                                    <FaCalculator className="text-white me-2 text-lg cursor-not-allowed" />
                                                    Calculate
                                                </button>
                                            </div>


                                        </Form>
                                    </>
                                )}
                            </Formik>
                            {/* {imageurlcalcy ? <img src={cbox} className='mt-11 rounded-lg inset-0 isolate hover:opacity-80 overflow-hidden bg-slate-900 h-60 -z-10 w-full object-cover object-right md:object-center' style={{ height: window.innerWidth >= 2500 ? '40vh' : '15rem' }} alt="" /> : <img src={dbox} className='mt-11 hover:opacity-80 rounded-lg inset-0 isolate overflow-hidden bg-slate-900 h-60 -z-10 w-full object-cover object-right md:object-center' style={{ height: window.innerWidth >= 2500 ? '40vh' : '15rem' }} alt="" />} */}
                            <p className='mt-6 text-sm'>In the rapidly globalizing world, logistics and Shipment services have become more essential than ever before. As businesses, individuals, and organizations look to expand their reach across borders, finding a reliable Shipment service to deliver goods and packages efficiently and securely is critical. One such service provider that stands out in the field of Global Shipment services is UK Logistics. Renowned for its commitment to excellence, UK Logistics offers a wide range of shipping solutions to cater to the diverse needs of its clients, both domestic and Global. With a focus on reliability, cost-effectiveness, and customer satisfaction, UK Logistics is undoubtedly one of the leading names in the Global Shipment industry.</p>
                        </div>
                        <div className="w-full lg:w-1/3 bg-white p-6 md:rounded-r-lg shadow-md mt-6 lg:mt-0 relative">
                            <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/planeglo.jpeg" alt="" className="rounded-lg hover:opacity-80" />
                            <div className="absolute bottom-7 left-0 w-full font-semibold bg-white bg-opacity-50 text-sm text-black text-center py-2">
                                Global Shipment Services
                            </div>
                        </div>

                    </div>
                </div>


            </div>


            {/* 
            <div className="mx-auto max-w-auto md:p-6 lg:px-8">
                <h1 className='font-bold text-xl mb-7'>{europeSelf.mainTitle}</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {europeSelf.destinations.map((item, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-lg overflow-hidden`}
                        >
                            <div
                                className="relative cursor-pointer"
                                onClick={() => toggleAccordion(index)} 
                            >
                                <img
                                    src={item.image}
                                    alt={item.destination}
                                    className="w-full h-48 object-cover"
                                />

                                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end text-white p-4">
                                    <h3 className="text-sm">To</h3>
                                    <p className="font-bold">{item.destination}</p>
                                    <div className="my-4">
                                        <h3 className="text-sm">Starting From / 21Kg</h3>
                                        <p className="font-bold">{item.price}</p>
                                    </div>
                                    <p className="text-sm">Estimated Delivery Time</p>
                                    <p className="font-bold">{item.deliveryTime}</p>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
           
            {expandedIndex !== null && (
                <div className="mx-auto max-w-auto md:px-6 lg:px-8">
                    <div
                        className="p-6 rounded-lg"
                        style={{
                            backgroundColor: "#E2E5F1",
                        }}
                    >
                        {europeSelf.destinations.map((detail, index) => {
                            if (expandedIndex === index) {
                                return (
                                    <>
                                        <h3 className="text-sm">To</h3>
                                        <p className="font-bold">{detail.destination}</p>
                                        <div key={detail.details.id} className="mb-4 mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                                            <div className="relative h-48 cursor-pointer rounded-lg overflow-hidden">
                                                <img
                                                    src={detail.image}
                                                    alt={detail.destination}
                                                    className="h-48 w-full object-cover rounded-lg"
                                                />
                                                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end text-white p-4 rounded-lg">
                                                    <h3 className="text-sm">To</h3>
                                                    <p className="font-bold">{detail.destination}</p>
                                                    <div className="my-4">
                                                        <h3 className="text-sm">Starting From / 21Kg</h3>
                                                        <p className="font-bold">{detail.price}</p>
                                                    </div>
                                                    <p className="text-sm">Estimated Delivery Time</p>
                                                    <p className="font-bold">{detail.deliveryTime}</p>
                                                </div>
                                            </div>

                                            <div className="flex flex-col justify-start space-y-2">
                                                <h5 className="text-lg mb-2 font-semibold">
                                                    Shipping Price List
                                                </h5>

                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{ backgroundColor: "#E2E5F1" }}>
                                                        {detail.details.priceDetails.slice(0, 5).map((priceItem, idx) => (
                                                            <p className="text-sm" key={idx}>
                                                                <span className="text-gray-500 font-semibold me-2">
                                                                    {priceItem.weight || priceItem.weightRange}
                                                                </span>
                                                                /
                                                                <span className="font-semibold ms-2">{priceItem.price}</span>
                                                            </p>
                                                        ))}
                                                    </div>

                                                    <div className="rounded-lg space-y-2.5" style={{ backgroundColor: "#E2E5F1" }}>
                                                        {detail.details.priceDetails.slice(5).map((priceItem, idx) => (
                                                            <p className="text-sm" key={idx}>
                                                                <span className="text-gray-500 font-semibold me-2">
                                                                    {priceItem.weight || priceItem.weightRange}
                                                                </span>
                                                                /
                                                                <span className="font-semibold ms-2">{priceItem.price}</span>
                                                            </p>
                                                        ))}
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="flex flex-col justify-start space-y-7">
                                                <div>
                                                    <h5 className="text-md mb-2 font-semibold">
                                                        Duties & Taxes
                                                    </h5>
                                                    <div className="flex space-x-10">
                                                        <div className="rounded-lg space-y-2.5" style={{
                                                            backgroundColor: "#E2E5F1",
                                                        }}>
                                                            <p className="text-sm text-gray-500 font-semibold">{detail.details.dutiesTaxes} </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <h5 className="text-md mb-2 font-semibold">
                                                        Estimated Delivery Time(Working days)
                                                    </h5>
                                                    <div className="flex space-x-10">
                                                        <div className="rounded-lg space-y-2.5" style={{
                                                            backgroundColor: "#E2E5F1",
                                                        }}>
                                                            <p className="text-sm text-gray-500 font-semibold">{detail.details.estimatedDeliveryTime}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <h5 className="text-md mb-2 font-semibold">
                                                        Weight Limit
                                                    </h5>
                                                    <div className="flex space-x-10">
                                                        <div className="rounded-lg space-y-2.5" style={{
                                                            backgroundColor: "#E2E5F1",
                                                        }}>
                                                            <p className="text-sm text-gray-500 font-semibold">{detail.details.weightLimit}</p>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>


                                        </div>

                                        <div className="space-y-7">
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    50% OFF on Global Shipment to Any Country
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.discounts}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Pickup and Packaging
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.pickupPackaging}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Multiple Boxes
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.multipleBoxes}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Restricted Items
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.restrictedItems}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Delivery Attempts
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.deliveryAttempts}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className='flex mt-7 justify-between'>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Suitable For
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.suitableFor}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <p className='text-sm text-center mb-2'>Proceed with Shipping</p>
                                                <button
                                                    className=" bg-slate-800 text-white font-semibold px-12 py-2 hover:bg-slate-900 rounded-lg"
                                                >
                                                    Ship Now
                                                </button>
                                            </div>

                                        </div>
                                    </>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
            )} */}

            <Footer />
        </div>
    )
}

export default ForeignAir
